import { useMutation, useQueryClient } from 'react-query';
import { Delete_One } from 'src/graphql/schema.graphql';
import { useAPIs } from 'src/hooks/useAPIs';
import { NeauviaItem } from 'src/models/directus';
import { QueryKey } from 'src/models/query';
import { deleteUserNoteGqlMutation } from 'src/modules/user/graphql/user-note-delete.mutation';
import { fetchUserNotes } from 'src/modules/user/hooks/useUserNotesQuery';

export const useMaterialsDeleteUserNoteMutation = (item: NeauviaItem) => {
  const apis = useAPIs();
  const queryClient = useQueryClient();

  return useMutation(async (variables: Delete_One) => {
    const directus = await apis.directus();

    const result = await directus.mutate(deleteUserNoteGqlMutation, variables);

    const updated = await fetchUserNotes(apis, item.id);

    queryClient.setQueryData(
      [...QueryKey.MaterialsUserNotes, item.id],
      () => updated,
    );

    return result;
  });
};
